import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class EstateTaxFormCanadaMeta extends BaseEntityModel {
  parentId?: number;
  craAmount?: number;
  quebecAmount?: number;

  constructor(model: Partial<EstateTaxFormCanadaMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.craAmount = model.craAmount;
    this.quebecAmount = model.quebecAmount;
  }
}
